import { handleResponse, handleError, headerset } from "../apiUtils";

const baseUrl = (produttore_id?: number) => {
  if (produttore_id) {
    return (
      process.env.API_URL + "/api/anagrafiche/produttori/" + produttore_id + "/"
    );
  } else {
    return process.env.API_URL + "/api/anagrafiche/produttori";
  }
};

export function fetchProduttori() {
  return fetch(baseUrl(), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: headerset().Authorization,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getProduttore(produttore_id: number) {
  let url = baseUrl(produttore_id);
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: headerset().Authorization,
    },
  })
    .then(handleResponse)
    .catch(handleError);
}
